import React from "react"; 
import '../../../App.css';


function lostAndFound () {

    return (
      <main className="project-page">
        {/* <MetaTags>
           <title>Matt Feeney Photography</title>
           <meta name="description" content="Matt Feeney Photography - Photo Gallery" />
         </MetaTags> */}
       <header className="project-page-intro">
         <p className="project-page-kicker">A photographic study</p>
         <h1>Lost and Found</h1>
       </header>
       <section>
          <div id="recent-work-container" className="row justify-content-center">
            <img src="../../../images/projects/signs-of-life/car.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="../../../images/recent-work/lisa-birds.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/icecream-people.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/looking-at-shore.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/pink.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/guard.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/protest.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/dragon-ride.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/yellow-slice.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/green-stairs.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
            <img src="images/recent-work/empty-chair.jpg" className="col-10 col-lg-9 mt-5" width="100%"/>
          </div>
         </section>
      </main>
    );
  }

export default lostAndFound;
